import script from "./GuesserView.vue?vue&type=script&lang=ts&setup=true"
export * from "./GuesserView.vue?vue&type=script&lang=ts&setup=true"

import "./GuesserView.vue?vue&type=style&index=0&id=47648508&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47648508"]])

export default __exports__